import { EProductType } from '@common/enums/product-type.enum';
import { t } from '@common/hooks/use-t.hook';
import { IIdObject } from '@common/interfaces/id-object.interface';
import { consoleService } from '@common/services/console.service';
import { getAddonProductTypeFromId } from '@common/utils/get-addon-product-type-from-id.utils';
import dayjs from 'dayjs';
import { apiHooks } from '../hooks/api-hooks';
import { EStockStatus, ISubscriptionSCForSale } from '../pack-house-generated-api';
import { IProductCatalogItemDto } from './product-catalog-item.dto';

export interface ISalesAddonDto extends Omit<ISubscriptionSCForSale, 'id'>, IIdObject {
    item?: IProductCatalogItemDto;
    price: number;
    clientStockStatus: string;
    physicalFrom: Date;
    physicalTo: Date;
    toString?: () => string;
    addonType: EProductType;
}

const STATUS_MAP: Record<EStockStatus, string> = {
    [EStockStatus.available]: t('Available'),
    [EStockStatus.empty]: t('Out of stock'),
    [EStockStatus.running_out]: t('Low stock'),
};
export const createSalesAddonDto = (it: ISubscriptionSCForSale): ISalesAddonDto => {
    const productCache = apiHooks.packHouse.getProductsFromCache();
    const item = productCache?.list.find((f) => f.id === it.item_id);
    if (!item) {
        consoleService.error('sales addon - item not found for id = ' + it.item_id);
    }
    return {
        ...it,
        id: it?.id || '',
        item,
        price: item?.price || 0,
        clientStockStatus: it.stock_status ? STATUS_MAP[it.stock_status] : '',
        toString: (): string => it.id || '',

        physicalFrom: dayjs((it.physical_availability_from_date || 0) * 1000).toDate(),
        physicalTo: dayjs((it.physical_availability_to_date || 0) * 1000).toDate(),
        addonType: getAddonProductTypeFromId(it.item_id || ''),
    };
};
